// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d38cf73c","455":"251c306f","977":"8d7fb26b"}[chunkId] + ".chunk.js";
};